import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from '../../../../../shared/components/date-picker/date-picker.component';
import { DocSignState } from '../doc-models';
import { DocumentCaseData } from '../../../../../core/services/document.models';

@Component({
    selector: 'app-doc-hipaa-authorization',
    standalone: true,
    imports: [CommonModule, FormsModule, DatePickerComponent],
    templateUrl: './doc-hipaa-authorization.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class DocHipaaAuthorizationComponent {
    @Input() state!:   DocSignState;
    @Input() caseData: DocumentCaseData | null = null;

    @Output() downloadPdf = new EventEmitter<void>();
    @Output() clearSig    = new EventEmitter<void>();
    @Output() mouseDown   = new EventEmitter<MouseEvent>();
    @Output() mouseMove   = new EventEmitter<MouseEvent>();
    @Output() mouseUp     = new EventEmitter<void>();
    @Output() touchStart  = new EventEmitter<TouchEvent>();
    @Output() touchMove   = new EventEmitter<TouchEvent>();
    @Output() touchEnd    = new EventEmitter<void>();

    @ViewChild('docCard',   { read: ElementRef }) docCard!:   ElementRef<HTMLElement>;
    @ViewChild('sigCanvas', { read: ElementRef }) sigCanvas!: ElementRef<HTMLCanvasElement>;

    get patientName():    string { return this.caseData?.patient_first_name ? `${this.caseData.patient_first_name} ${this.caseData.patient_last_name}` : '[Patient First Name] [Patient Last Name]'; }
    get patientDob():     string { return this.caseData?.patient_dob     ?? '[DOB]'; }
    get patientAddress(): string { return this.caseData?.patient_address ?? '[Patient Address]'; }
    get dateOfService():  string { return this.caseData?.date_of_service ?? '[Date of Service]'; }
    get ssnLast4():       string { return this.caseData?.ssn_last4       ?? '****'; }
}
